import { FC, useState } from "react";

import { Stack } from "@mui/material";

import { AdminMenus } from "../../../utils/AdminMenus";

const getModuleIcon = (module: string): any => {
    return AdminMenus.get(module)!.Icon;
}

interface StartupPageProps {
    selectModule: (module: string, handler: number) => void;
}

const StartupPage: FC<StartupPageProps> = ({ selectModule }) => {
    const [favouriteModules, setFavouriteModules] = useState<string[]>([]);

    useState(() => {
        const favourites: string[] = JSON.parse(localStorage.getItem('favouriteModules') || '[]');
        setFavouriteModules(favourites);
    });

    function handleModuleClick(module: string) {
        selectModule(module, AdminMenus.get(module)!.Handler);
    }

    return (
        <Stack>
            <Stack sx={{ marginTop: "10%", width: "100%", alignItems: "center" }}>
                <img
                    width={"60%"}
                    src={"https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/logos/startupAdmin.png"}
                />
            </Stack>

            {favouriteModules.length > 0 ?
                <Stack
                    sx={{ marginTop: "100px" }}
                    direction="row"
                    spacing={1}>
                    {favouriteModules.map((module) => (
                        <Stack
                            key={module}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            spacing={1}
                            onClick={() => handleModuleClick(module)}
                            role="button"
                            sx={{
                                height: 100,
                                padding: 2,
                                border: '1px solid rgba(0,0,0,0.3)',
                                borderRadius: 2,
                                cursor: 'pointer',
                                userSelect: 'none',
                                transition: 'box-shadow 0.15s, transform 0.15s',
                                '&:hover': {
                                    boxShadow: 3,
                                    transform: 'translateY(-2px)',
                                    bgcolor: 'rgba(0,0,0,0.03)'
                                }
                            }}>
                            {getModuleIcon(module)}
                            <span style={{ fontWeight: 600, textAlign: 'center', fontSize: '20px' }}>{module}</span>
                        </Stack>
                    ))}
                </Stack>
                :
                null
            }
        </Stack>
    )
}

export default StartupPage;
